import { on } from "@ngrx/store";
import { ApplicationStore } from "../application.state";
import { ClipboardActions } from "./clipboard.actions";

// **************************************************************************
// CLIPBOARD REDUCER (array format for spreading in parent)
// **************************************************************************

const update = on(ClipboardActions.update, (state: ApplicationStore, { data }) => ({
    ...state,
    clipboard: {
        ...state.clipboard,
        copiedEntity: data,
    },
}));

export const clipboardReducer = [update];
